import React, { useState, useEffect } from 'react'
import {
  TextField, makeStyles, Typography, Box, Button, Grid, Paper,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import { useLocation, useParams } from 'react-router-dom'

import {
  getRefereeEventUsers,
  //  getRefereeEvent,
  refereeEvent,
  selectorRefereeEventUsers,
} from 'src/app/slices/eventSlice'
import { useDispatch, useSelector } from 'react-redux'
import UserEventFiles from './UserEventFiles'

// const TAGS = {
//   mp4: `<video width="400" height="250" controls><source src=${''} type=${''} /></video>`,
//   mp3: '<audio width="400" height="250" controls><source src=\'\' type=\'\' /></audio>',
//   jpeg: `<img src=${''} alt='file' />`,
//   pdf: <embed src="file_name.pdf" width="800px" height="2100px" />,
//   zip: `<img src=${''} alt='file' />`,
// }

// const MIMETYPE = 'jpeg'
// const USER_FILE = ''

const CssTextField = withStyles((theme) => ({
  root: {
    width: '100%',
    height: '10vw',
    margin: '0 auto!important',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      width: '70vw',
      height: '40vw',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '2px dashed orange',
      borderRadius: '59rem',
    },
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
    '& textarea': {
      width: '96%',
      margin: '0 auto',
    },
  },
}))(TextField)

const useStyles = makeStyles((theme) => ({
  container: {
    overflowX: 'hidden !important',
    marginTop: '50px',
    display: 'flex !important',
    flexFlow: 'column !important',
    '@media (max-width: 800px)': {
      width: '94vw',
    },
  },
  textField: {
    width: '100%',
  },
  btnBox: {
    display: 'flex',
    margin: '2rem 0',
    marginRight: 'auto',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  btn: {
    color: 'white',
    padding: '1rem 4rem',
    borderRadius: '5rem',
    fontSize: '18px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnSuccess: {
    marginRight: '1rem',
    backgroundColor: 'rgb(157 215 160)',
    '&:hover': {
      backgroundColor: 'rgb(157 215 160)',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      marginRight: '0',
      marginBottom: '1rem',
    },
  },
  btnFail: {
    backgroundColor: '#dd8a86',
    '&:hover': {
      backgroundColor: '#dd8a86',
    },
  },
  titleBox: {
    marginBottom: '2rem',
  },
  acceptFile: {
    width: '100%',
    borderRadius: '20px',
    height: '5rem',
    display: 'flex',
    cursor: 'pointer',
    margin: '0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px dashed orange',
  },
  boxSend: {
    width: '100%',
    // height: '50vh',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    // overflowY: 'scroll',
  },
  btnDownload: {
    margin: '1rem 0',
    alignSelf: 'flex-end',
    backgroundColor: '#e8e8e8',
  },
  filesWrapper: {
    marginBottom: '2rem',
    // border: '2px dashed orange',
    // width: '10vw',
    // height: '200px',
    '@media (max-width: 800px)': {
      width: '100%',
      marginBottom: '22vw',
      // height: '100px',
    },
  },
  fileWrapper: {
    backgroundColor: '#000',
  },
  file: {
    width: 'inherit',
    objectFit: 'cover',
  },
  condition: {
    padding: '1rem',
    borderRadius: '1rem',
  },
  description: {
    margin: '1rem 0',
    padding: '1rem',
    border: '.5px solid rgba(0,0,0,.5)',
  },
  listItemTitle: {
    textAlign: 'center',
  },
  list: {
    width: '100%',
    padding: '0 1rem',
    boxShadow: '0 0 1px 0 rgba(26, 24, 24, 0.2)',
    backgroundColor: '#fff',
  },
  listItem: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    gridColumnGap: theme.spacing(2),
    margin: '1rem 0',
  },
  conditionWrapper: {
    margin: '50px 0',
  },
  submitBtn: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
  },
  btnSubmitSuccess: {
    marginRight: '1rem',
    backgroundColor: 'rgb(0 149 7)',
    '&:hover': {
      backgroundColor: 'rgb(157 215 160)',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      marginRight: '0',
      marginBottom: '1rem',
    },
  },
  refereeCommentsWrapper: {
    backgroundColor: '#fff',
    borderRadius: '20px',
    padding: '10px 30px',
  },
  refereeCommentsTitle: {
    color: '#f9b233',
    fontSize: '1.5rem',
    fontWeight: 600,
    marginTop: '20px',
  },
  comment: {
    color: '#000',
    fontSize: '1rem',
    fontWeight: 500,
    margin: '10px',
    lineHeight: '30px',
  },
  refereeCommentWrapper: {
    padding: '20px',
  },
}))

const RefereeEventComment = () => {
  const classes = useStyles()
  const state = useLocation().state || ''
  const dispatch = useDispatch()
  const loggedInUser = useSelector((s) => s.user.role.roleId)
  const comments = useSelector(selectorRefereeEventUsers)
  const { id } = useParams()

  console.log(comments, 'cgfngfjnfhjf')

  const [description, setDescription] = useState('')
  const [status, setStatus] = useState('')
  // const [disableBtn, setDisableBtn] = useState(false)
  const handleDescription = (e) => setDescription(e.target.value)

  useEffect(() => {
    dispatch(getRefereeEventUsers({ UserEventId: id }))
  }, [+id])

  useEffect(() => {
    // dispatch(getRefereeEvent({
    //   UserEventId: 20,
    // }))
    // dispatch(getRefereeEventUsers({ UserEventId: state?.id }))

    const labelAccept = document.querySelector('#accept_lable')
    const labelReject = document.querySelector('#reject_lable')
    if (status === '1') {
      labelAccept.style.backgroundColor = 'rgb(0 149 7)'
      labelReject.style.backgroundColor = ''
    } else if (status === '2') {
      labelAccept.style.backgroundColor = ''
      labelReject.style.backgroundColor = '#e6332a'
    }
  }, [status])

  const handleSubmit = (e) => {
    e.preventDefault()

    const data = {
      UserEventId: state?.id,
      Status: +status,
      Description: description,
    }
    dispatch(refereeEvent(data))
  }

  const handleChange = (e) => {
    setStatus(e.target.value)
  }

  const firstStagecomments = comments?.filter((c) => +c?.eventStage?.order === 1)
  const secondStagecomments = comments?.filter((c) => +c?.eventStage?.order === 2)

  return (
    <div className={classes.container}>
      <Typography variant="h3" component="h3">
        عنوان رویداد :
        {' '}
        {state.event.title}
      </Typography>
      <Grid item xs={12} md={12} className={classes.conditionWrapper}>
        <Paper classes={{ root: classes.condition }}>
          <Typography color="textPrimary" gutterBottom variant="h4">
            شرایط و قوانین
          </Typography>
          <Box classes={{ root: classes.description }}>
            {state?.event?.laws.split('\n').map((item) => {
              return (
                <Typography classes={{ root: classes.legal }} variant="body2">
                  &#9899;
                  {' '}
                  {item}
                  <br />
                </Typography>
              )
            })}
          </Box>
        </Paper>
      </Grid>
      <Typography
        classes={{ root: classes.titleBox }}
        variant="subtitle1"
      >
        کد شرکت کننده :‌
        {' '}
        {state?.user?.userName}
      </Typography>
      <Box classes={{ root: classes.boxSend }}>
        <Typography
          classes={{ root: classes.filesWrapper }}
          variant="div"
          component="div"
        >
          {/* فایل ارسالی */}
          {/* {USER_FILE} */}
          {/* <div className={classes.fileWrapper}> */}
          <UserEventFiles
            attachments={state?.attachedFiles}
          />
          {/* </div> */}
          {(state?.attachedFiles?.[0]?.mimeType !== 'image/png' || state?.attachedFiles?.[0]?.mimeType !== 'image/jpeg') && <br />}

          {comments?.length ? (
            <div className={classes.refereeCommentsWrapper}>
              {loggedInUser === 10 && (
                firstStagecomments?.length
                  ? (
                    <>
                      <p className={classes.refereeCommentsTitle}>نظرات داوران مرحله اول</p>
                      <div>
                        {firstStagecomments?.map((comment) => (
                          <div className={classes.refereeCommentWrapper}>
                            <span className={classes.comment}>{comment?.referee?.userName}</span>
                            -
                            <span
                              className={classes.comment}
                              style={{
                                backgroundColor: comment?.status === 1 ? 'green' : 'red',
                                padding: '3px 15px',
                                borderRadius: '20px',
                                color: '#fff',
                              }}
                            >
                              {comment?.status === 1 ? 'قبول شده' : 'رد شده'}
                            </span>
                            -
                            <span className={classes.comment}>{comment?.description}</span>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : null
              )}
              {loggedInUser === 10 && (
                secondStagecomments?.length ? (
                  <>
                    <p className={classes.refereeCommentsTitle}>نظرات داوران مرحله دوم</p>
                    <div>
                      {secondStagecomments?.map((comment) => (
                        <div className={classes.refereeCommentWrapper}>
                          <span className={classes.comment}>{comment?.referee?.userName}</span>
                          -
                          <span
                            className={classes.comment}
                            style={{
                              backgroundColor: comment?.status === 1 ? 'green' : 'red',
                              padding: '3px 15px',
                              borderRadius: '20px',
                              color: '#fff',
                            }}
                          >
                            {comment?.status === 1 ? 'قبول شده' : 'رد شده'}
                          </span>
                          -
                          <span className={classes.comment}>{comment?.description}</span>
                        </div>
                      ))}
                    </div>
                  </>
                ) : null
              )}
            </div>
          ) : null}
        </Typography>

      </Box>
      {/* {USER_FILE} */}
      {loggedInUser !== 10 && (
      <form onSubmit={handleSubmit}>
        <Box classes={{ root: classes.btnBox }}>
          <label
            htmlFor="accept"
            id="accept_lable"
            className={`${classes.btn} ${classes.btnSuccess}`}
          >
            قبول
            <input type="radio" id="accept" name="status" hidden value="1" onChange={handleChange} />
          </label>
          <label
            htmlFor="reject"
            id="reject_lable"
            className={`${classes.btn} ${classes.btnFail}`}
          >
            رد
            <input type="radio" id="reject" name="status" hidden value="2" onChange={handleChange} />
          </label>
        </Box>
        <CssTextField
          classes={{ root: classes.textField }}
          fullWidth
          placeholder="توضیح در صورت نیاز"
          type="text"
          size="small"
          variant="outlined"
          multiline
          rows={3}
          rowsMax={10}
          onChange={handleDescription}
        />
        <div className={classes.submitBtn}>
          <Button
            type="submit"
            classes={{
              root: classNames(classes.btn, classes.btnSubmitSuccess),
            }}
          >
            ارسال
          </Button>
        </div>
      </form>
      )}

    </div>
  )
}
export default RefereeEventComment
